/**
 * How far to pan one axis so the popup clears both of its edges.
 *
 * Panning BY the overflow moves the map under the popup. Only one side of an axis can be acted on, so when
 * the popup is taller or wider than the viewport the start edge wins and its top-left stays visible — what
 * Leaflet's auto-pan did.
 */
export const resolveAxisPan = (
  overflowStart: number,
  overflowEnd: number,
): number => {
  if (overflowStart > 0) {
    return -overflowStart;
  }

  return overflowEnd > 0 ? overflowEnd : 0;
};
